import _ from 'lodash';
import Vue from 'vue';
var numeral = require('numeral');

export const state = () => ({
  selections: [],
  selectionsLive: [],
  stakeDefault: 10,
  stakeSingle: 10,
  stakeCombi: 10,
  stakeSystem: 10,
  stakes: {},
  betType: 'single',
  lastUsedStake: null,
  processingStatus: null,
  error: null,
  visible: false,
  updatedAt: null,
  insured: {},
})

export const mutations = {
  toggleBetslip(state, visible = null) {
    console.log('toggleBetslip', visible)
    if(_.isNull(visible))
      state.visible = !this.state.visible;
    else
      state.visible = visible;
  },
  setError(state, error) {
    state.error = error;
  },
  setBetType(state, betType) {
    state.betType = betType;
  },
  setInsured(state, payload) {
    if (payload.value) {
      Vue.set(state.insured, payload.key, true);
    } else {
      Vue.delete(state.insured, payload.key);
    }
  },
  setLastUsedStake(state, value) {
    state.lastUsedStake = value;
  },
  setStakeSingle(state, value) {
    state.stakeSingle = value;
  },
  setStakeCombi(state, value) {
    state.stakeCombi = value;
  },
  setStakeSystem(state, value) {
    state.stakeSystem = value;
  },
  setSelectionsLive(state, value) {
    state.selectionsLive = value;
  },
  setSelections(state, value) {
    state.selections = value;
  },
  setProcessingStatus(state, value) {
    state.processingStatus = value;
  },
  setStakes(state, payload) {
    console.log('setStakes', payload);
    Vue.set(state.stakes, payload.key, payload.value);
  },
  setEachway(state, payload) {
    state.selections = _.map(state.selections, function(selection) {
      if(_.get(selection, 'outcome.id') === _.get(payload, 'key')) {
        selection.outcome.is_each_way = payload.value
      }
      return selection;
    });
  },
  setStakesBatch(state, value) {
    let stakes = {};
    for(let selection of  state.selections) {
      stakes[_.get(selection, 'outcome.id')] = numeral(value).value();
    }
    console.log('setStakesBatch', stakes);
    state.stakes = stakes;
  },  
  clearStakes(state, payload) {
    state.stakes = {};
  },
  add(state, item) {
    if(state.stakeSingle) {
      _.set(state, 'stakes.'+_.get(item, 'outcome.id'), state.stakeSingle);
    }
    if(state.processingStatus == 'completed'){
      state.selections = [];
      state.processingStatus = null
      state.insured = {};
    }
    state.selections.push(item)
    state.updatedAt = new Date();
  },
  remove(state, item) {
    state.selections = _.reject(state.selections, function(selection) {
      return  _.get(selection, 'outcome.id') === _.get(item, 'outcome.id');
    });
    Vue.delete(state.insured, _.get(item, 'outcome.id'));
    state.updatedAt = new Date();
  },
  clear(state) {
    state.selections = []
    state.betType = 'single'
    state.insured = {}
  }
}
